import Ajax from '@lib/ajax'

export default {

  /*********************
  * MENU ITEMS
  **********************/
  async createEditMenuItem(payload){
    return Ajax.post('/api/services/app/Navigation/CreateEditMenuItem', payload);
  },
  async getMenuItemsByMenuId(id){
    return Ajax.get('/api/services/app/Navigation/GetMenuItemsByMenuId?Id='+ id);
  },
  async deleteMenuItemByMenuId(menuId,menuItemId){
    return Ajax.delete('/api/services/app/Navigation/DeleteMenuItemByMenuId?menuId=' + menuId + "&id=" + menuItemId);
  },

  /*********************
  * MENU
  **********************/
  async createEditMenu(payload){
    return Ajax.post('/api/services/app/Navigation/CreateEditMenu',payload);
  },
  async getMenu(id){
    return Ajax.get('/api/services/app/Navigation/GetMenu?Id='+ id);
  },
  async getNavigationMenuGridResult(payload){
    return Ajax.get('/api/services/app/Navigation/getNavigationMenuGridResult', payload);
  },
  async delete(id){
    return Ajax.delete('/api/services/app/Navigation/DeleteAsync?Id='+ id);
  },
  
}